import React, { FC } from 'react'
import { DivProps } from '@commonTypes'
import cn from 'classnames'
import css from './assetSpaces.module.scss'

type TableWrapperProps = DivProps & {
  withSelection: boolean
}

const TableWrapper: FC<React.PropsWithChildren<TableWrapperProps>> = ({
  withSelection,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(css.table_wrapper, className, { [css.with_selection]: withSelection })}
      {...props}
    />
  )
}

export default TableWrapper
